import React from "react";
import { Button, Modal, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

import { useTranslation } from "react-i18next";
import * as Styled from "./styles";

interface ModalTemporaryPasswordProps {
  email: string | null;
  isOpen: boolean;
  typeProfile: string | undefined;

  onClose: () => void;
}

const ModalTemporaryPassword = ({
  email,
  isOpen,
  typeProfile,
  onClose,
}: ModalTemporaryPasswordProps) => {
  const { t } = useTranslation();
  return (
    <Modal open={isOpen} onClose={onClose} closeAfterTransition keepMounted>
      <Styled.Content>
        <Typography variant="h6" mb={2}>
          {t("temporaryPassword")}
        </Typography>
        <Typography variant="subtitle1">
          {typeProfile === "deliveryman"
            ? t("forFirstAccess")
            : t("passwordCreatedSuccessfully")}
        </Typography>
        <Typography variant="subtitle1" mb={2}>
          {typeProfile !== "deliveryman" && t("sendEmailTemporaryPassword")}
        </Typography>
        <Styled.ViewData>
          <Typography variant="subtitle1" mb={2}>
            {typeProfile === "deliveryman"
              ? t("temporaryPassword")
              : t("emailSentTo")}
            {email && <Typography variant="h5">{email}</Typography>}
          </Typography>
        </Styled.ViewData>
        <Styled.ActionsContainer>
          <Button
            color="inherit"
            endIcon={<CloseIcon />}
            variant="text"
            onClick={onClose}
          >
            {t("close").toUpperCase()}
          </Button>
        </Styled.ActionsContainer>
      </Styled.Content>
    </Modal>
  );
};

export default ModalTemporaryPassword;
